import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { ManagementContainerFreightStorageModel, ManagementUpdateContainerFreightStorageModel } from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class ContainerFreightStoragesRepository {
  constructor(private apiService: ApiService) {}

  public get(id: ManagementContainerFreightStorageModel['id'], isShowLoader?: boolean): Observable<ManagementContainerFreightStorageModel> {
    return this.apiService.get<ManagementContainerFreightStorageModel>(
      `${environment.url.freight.containerStoragesManagement}/${id}`,
      null,
      {
        isShowLoader,
      },
    );
  }

  public update(
    id: ManagementContainerFreightStorageModel['id'],
    model: ManagementUpdateContainerFreightStorageModel,
    isShowLoader?: boolean,
  ): Observable<ManagementContainerFreightStorageModel> {
    return this.apiService.put<ManagementContainerFreightStorageModel>(
      `${environment.url.freight.containerStoragesManagement}/${id}`,
      model,
      null,
      {
        isShowLoader,
      },
    );
  }
}
